import { useState } from "react";
import cardsImg from "../../assets/img/cards.png";
import cardsImgWebp from "../../assets/img/cards.webp";

type Props = {
    title: string,
    subtitle: string,
    imgSrc: string,
    imgSrcWebp: string,
    bottlePrice: number,
    savings: number,
    hasGift: boolean,
    total: number,
    totalWithDiscount: number,
    isFreeShipping: boolean,
    buyLink: string,
    gtmLabel: string,
    gtmProduct: string,
    showBorder: boolean,
};

const BuyCard = ({
    title,
    subtitle,
    imgSrc,
    imgSrcWebp,
    bottlePrice,
    savings,
    hasGift,
    total,
    totalWithDiscount,
    isFreeShipping,
    buyLink,
    gtmLabel,
    gtmProduct,
    showBorder,
}: Props) => {
    const [hovered, setHovered] = useState(showBorder);


    return (
        <div
            className={`text-center border border-2 gg-buy-card-border-radius gg-hover-shadow ${hovered ? 'gg-hover-shadow-hovered' : ''}`}
        // onMouseEnter={() => setHovered(true)}
        // onMouseLeave={() => setHovered(false)}
        >
            <h2 className="fw-bold mb-0 mt-4">{title}</h2>
            <small>{subtitle}</small>
            <div className="py-3">
                <picture>
                    <source srcSet={imgSrcWebp} type="image/webp" />
                    <img className="img-fluid" src={imgSrc} loading="lazy" />
                </picture>
            </div>
            <div className="d-flex justify-content-center align-items-center">
                <h1 className="display-4 fw-bold">${bottlePrice}</h1>
                <small className="text-muted">/bottle</small>
            </div>
            <div className="fw-bold">
                You save ${savings}
            </div>
            {hasGift ?
                <div> +2 Free Bonuses</div> : <br />
            }
            <div className="mt-2">
                <a href={buyLink} className="text-decoration-none btn gg-button-buy-yellow gg-buy-card-button gg-bigger-button fw-bold fs-5 gtm-buy-btn" data-gtm-label={gtmLabel} data-gtm-product={gtmProduct} data-gtm-price={totalWithDiscount}>Add to Cart</a>
            </div>
            <div className="my-3">
                90-day money back guarantee
            </div>
            <div>
                <picture>
                    <source srcSet={cardsImgWebp} type="image/webp" />
                    <img className="img-fluid gg-cards-max-height" src={cardsImg} loading="lazy"/>
                </picture>                
            </div>
            <div className="my-3">
                Total:
                <span className="text-decoration-line-through">${total}</span>
                <span className="fw-bold"> ${totalWithDiscount}</span>
                <div className={`${isFreeShipping ? 'fw-bold' : ''}`}>+ {isFreeShipping ? ('FREE US SHIPPING') : ('SHIPPING')}</div>
            </div>
        </div>
    );
};

export default BuyCard;